import React from "react";
import "./SingleJobPostHeroSection.scss";
import Clock from "../../images/Clock";
import MapPin from "../../images/MapPin";
import { NavLink } from "react-router-dom";

const SingleJobPostHeroSection = ({ data }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <section className={"single-job-post-hero-section"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className="col-8 offset-2">
            <h1>{data.title.rendered}</h1>
            <div className="job-meta">
              <div className="locations">
                <MapPin />
                {data.acf.location.map((location, i) => (
                  <span key={i} className={location}>
                    {location}
                  </span>
                ))}
              </div>
              <div className="types">
                <Clock />
                {data.acf.type.map((type, i) => (
                  <span key={i} className={type}>
                    {type}
                  </span>
                ))}
              </div>
            </div>
            <NavLink
              to="#apply"
              className={"btn"}
              onClick={(e) => {
                e.preventDefault(); // Prevent default navigation
                scrollToSection("apply");
              }}
            >
              Apply Now
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SingleJobPostHeroSection;
